import { useLingui } from "@lingui/macro";
import {
  errorCode,
  isFieldValidationFailure,
  type ErrorCode,
} from "@app/components/organisation/types";

/** The reader's sentence for an API refusal: its code when known, else ``fallback``. */
export function useOrganisationMessages() {
  const { t } = useLingui();
  const messages: Record<ErrorCode, string> = {
    siret_invalide: t`Ce SIRET n'est pas valide : vérifiez les 14 chiffres.`,
    code_postal_invalide: t`Le code postal doit compter 5 chiffres.`,
    siret_inconnu: t`Aucun établissement ne porte ce SIRET dans le répertoire des entreprises.`,
    registre_indisponible: t`Le répertoire des entreprises ne répond pas : saisissez les informations à la main.`,
    raison_sociale_requise: t`Renseignez la raison sociale.`,
    prenom_nom_requis: t`Renseignez le prénom et le nom.`,
    lecture_seule: t`Seul un gestionnaire peut modifier cette organisation.`,
    editeur_reserve_admin: t`Seul un administrateur MAGE-X gère les membres de cette organisation.`,
    compte_demo: t`L'organisation de démonstration ne se modifie pas.`,
    conflit: t`Cette action vient d'être faite par ailleurs : rechargez la page.`,
    deja_membre: t`Cette personne est déjà membre de l'organisation.`,
    deja_invite: t`Une invitation attend déjà cette adresse.`,
    dernier_gestionnaire: t`L'organisation doit garder au moins un gestionnaire.`,
    invitation_introuvable: t`Cette invitation n'est plus valable.`,
    organisation_introuvable: t`Cette organisation est introuvable.`,
    membre_introuvable: t`Ce membre ne fait plus partie de l'organisation.`,
  };

  function failureMessage(res: unknown, fallback: string): string {
    const code = errorCode(res);
    if (code) return messages[code];
    if (isFieldValidationFailure(res)) {
      return t`Certains champs sont invalides : vérifiez le formulaire.`;
    }
    return fallback;
  }

  return { messages, failureMessage };
}
